<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <template v-if="!loggedIn">
        <div class="app-content p-0">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 w-100 d-flex align-items-center">
              <div class="container-fluid">
                <div class="row">
                  <div
                    class="col-md-6 pl-0 d-none d-sm-flex align-items-center hide-image"
                  >
                    <div class="wrap" :style="wrapStyle">
                      <img
                        src="@/assets/login.jpg"
                        alt="login izidok"
                        :style="wrapImgStyle"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 d-flex justify-content-center align-self-center">
                    <div>
                      <div class="row mb-5">
                        <div class="col-md-12 text-center">
                          <img
                            src="/img/izidok.baaa69b4.png"
                            alt="izidok"
                            class="img-fluid"
                            style="width: 45% !important;height:100%;"
                          />
                        </div>
                      </div>
                      <div>
                        <label class="mb-3 mt-3">
                          Masukkan Email / No. Handphone
                        </label>
                        <label style="color:red"> *</label>
                        <div>
                          <b-form @submit.prevent="submitForm">
                            <template
                              v-if="formBasicData && formBasicData.length"
                            >
                              <b-form-group
                                v-for="form in formBasicData"
                                :key="form.tmpId"
                                class="text-capitalize"
                                :invalid-feedback="
                                  renderInvalidFeedback({
                                    validationDesc: form['validation-desc']
                                  })
                                "
                                style="position: relative"
                                :state="renderError({ error: form.error })"
                              >
                                <template
                                  v-if="
                                    form.type === 'password' ||
                                      form.isType == 'password'
                                  "
                                >
                                  <label class="mb-3 mt-3">
                                    Password
                                  </label>
                                  <label style="color:red"> *</label>
                                  <b-input-group>
                                    <b-input-group-text
                                      slot="append"
                                      class="border-left-0"
                                      @click="switchVisibility"
                                    >
                                      <font-awesome-icon
                                        v-if="passwordVisible == false"
                                        icon="eye"
                                      />
                                      <font-awesome-icon
                                        v-else
                                        icon="eye-slash"
                                      />
                                    </b-input-group-text>
                                    <b-form-input
                                      :type="form.type || 'text'"
                                      class="border-right-0"
                                      autocomplete="off"
                                      @keyup="
                                        setValue({
                                          rawLabel: form.rawLabel,
                                          label: form.label,
                                          $event,
                                          tmpId: form.tmpId
                                        })
                                      "
                                      :state="
                                        renderError({ error: form.error })
                                      "
                                      :maxlength="form.maxLength"
                                      :placeholder="form.placeholder"
                                    />
                                  </b-input-group>
                                </template>
                                <template v-else>
                                  <b-form-input
                                    :type="form.type || 'text'"
                                    autocomplete="off"
                                    @keyup="
                                      setValue({
                                        rawLabel: form.rawLabel,
                                        label: form.label,
                                        $event,
                                        tmpId: form.tmpId
                                      })
                                    "
                                    :state="renderError({ error: form.error })"
                                    :maxlength="form.maxLength"
                                    :placeholder="form.placeholder"
                                  />
                                </template>
                              </b-form-group>
                            </template>
                            <b-alert :show="isMaxFailed" variant="danger"
                              >Anda telah gagal login terlalu banyak.
                            </b-alert>
                            <template>
                              <router-link
                                to="/forgot-password"
                                style="margin-top : 15px;"
                                >Lupa password?</router-link
                              >
                            </template>
                            <button
                              class="btn btn-lg btn-block mt-2 "
                              :disabled="isMaxFailed"
                              style="background-color :#3F7EA7; color:white; border-radius : 10px;"
                            >
                              Masuk
                            </button>
                          </b-form>
                        </div>
                        <div class="pt-4 text-center" style="color:gray">
                          Tidak memiliki akun?
                          <router-link
                            tag="a"
                            to="/register"
                            exact
                            title="Daftar di sini"
                            >Daftar di sini</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template
        v-if="
          firstJoin && userData.klinik.tipe_faskes.type === 'klinik' && loggedIn
        "
      >
        <first-join-component-klinik :modalShow="firstJoin" />
      </template>
      <template
        v-if="
          firstJoin && userData.klinik.tipe_faskes.type !== 'klinik' && loggedIn
        "
      >
        <first-join-component :modalShow="firstJoin" />
      </template>
    </div>
  </div>
</template>

<script>
// reset state
localStorage.removeItem("_izd_");

import { mapMutations, mapState } from "vuex";
import startCase from "lodash/startCase";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEye,
  faEyeSlash,
  faInfo,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

library.add(faEye, faInfo, faEyeSlash, faCheckCircle);

const maxFailed = 3;
const maxFailedCounter = 5; // minutes

export default {
  data: () => ({
    formBasicData: null,
    formData: null,
    userData: null,
    loggedIn: false,
    firstJoin: false,
    passwordVisible: false,
    failedCounter: 0,
    windowHeight: 0,
    selectedType: null,
    dpm: {
      card: "card",
      src: "/img/dpm.png",
      class: "m-0"
    },
    klinik: {
      card: "card",
      src: "/img/klinik.png",
      class: "m-0"
    },
    maxFailedTimestamp: localStorage.getItem("__tmfl__"),
    isMaxFailed: true
  }),
  components: {
    "first-join-component": () => import("@/components/FirstJoin"),
    "first-join-component-klinik": () => import("@/components/FirstJoinKlinik")
  },
  computed: {
    ...mapState(["sidebarCollapsed, 'initializationPage"]),
    wrapStyle() {
      return {
        height: this.windowHeight + "px"
      };
    },
    wrapImgStyle() {
      return {
        "max-height": this.windowHeight + "px"
      };
    }
  },
  validations: {
    formData: {
      ["email/No.Handphone"]: {
        required,
        maxLength: maxLength(50)
      },
      password: {
        required,
        minLength: minLength(6)
      }
    }
  },
  mounted() {
    this.formBasicData = this.setFormBasicData();
    this.formData = this.setFormData();

    this.isMaxFailed = this.maxFailedTimestamp >= moment().unix();
    setInterval(() => {
      this.isMaxFailed = this.maxFailedTimestamp >= moment().unix();
    }, 1000);

    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", e => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
  watch: {
    selectedType() {
      if (this.selectedType == "dpm") {
        this.dpm = {
          card: "card card-blue",
          src: "/img/dpm_blue.png",
          class: "m-0 text-blue"
        };
        window.location.href = "https://app.izidok.id/login";
      } else {
        this.dpm = {
          card: "card",
          src: "/img/dpm.png",
          class: "m-0"
        };
      }

      if (this.selectedType == "klinik") {
        this.klinik = {
          card: "card card-blue",
          src: "/img/klinik_blue.png",
          class: "m-0 text-blue"
        };
      } else {
        this.klinik = {
          card: "card",
          src: "/img/klinik.png",
          class: "m-0"
        };
      }
    }
  },
  methods: {
    ...mapMutations({
      collapseSidebar: "sidebar/SET_SIDEBAR_COLLAPSED",
      setInitPage: "sidebar/SET_INITIALIZATION_PAGE",
      setInitPosition: "SET_INIT_POSITION"
    }),
    switchVisibility() {
      this.formBasicData[1].type == "password"
        ? (this.formBasicData[1].type = "text")
        : (this.formBasicData[1].type = "password");
      if (this.formBasicData[1].type == "text") {
        this.passwordVisible = true;
      } else if (this.formBasicData[1].type == "password") {
        this.passwordVisible = false;
      }
    },

    async login() {
      localStorage.removeItem("survey");
      localStorage.removeItem("klinik");
      this.loggedIn = false;
      try {
        const { formData } = this;
        const mapLabel = label => {
          switch (true) {
            case /(email|username)/gi.test(label):
              return "username";
            default:
              return label;
          }
        };
        const postData = Object.keys(formData)
          .map(item => ({
            label: mapLabel(item),
            value: formData[item]
          }))
          .reduce((obj, key) => {
            obj[key.label] = key.value;
            obj["tipe_faskes"] = this.selectedType == "dpm" ? 2 : 1;
            return obj;
          }, {});
        const res = await this.$axios.post(`login`, postData);
        const { status, message, data } = res.data;

        if (status) {
          this.loggedIn = true;
          this.firstJoin = data.first_login;
          data.user.klinik = data.klinik;
          this.userData = data;

          if (data.klinik.tipe_faskes.type === "klinik") {
            //untuk pic di survey
            if (data.init_position == "survey") {
              localStorage.setItem("survey", false);
              localStorage.setItem("klinik", true);
            } else if (data.init_position == "klinik") {
              localStorage.setItem("survey", false);
              localStorage.setItem("klinik", true);
            }

            this.setInitPosition(data.init_position);
          } else {
            this.setInitPosition(data.init_position);
          }

          this.$store.commit("SET_UPLOAD_PASIEN", null);
          this.$store.commit("SET_USER", data.user);
          this.$store.commit("SET_BEARER_TOKEN", data.token);
          this.$store.commit("SET_ROLES", data.roles);
          this.$store.commit("SET_FASKES", data.tipe_faskes);
          this.$store.commit("SET_KLINIK_USER", data.kliniks);
          this.$store.commit("SET_IS_FASKES_DPM", data.is_dpm);

          if (data.tipe_faskes == "2") {
            this.$store.commit("SET_KLINIK_ID", data.user.klinik.id);
          } else {
            this.$store.commit("SET_KLINIK_ID", data.kliniks[0].id);
          }
          localStorage.setItem("IDLE", 0);
          localStorage.setItem("REMINDER", 1);
          localStorage.removeItem("TIPE_FASKES");

          const isBidan = data.kliniks[0].is_bidan;
          const isPharmanet = data.kliniks[0].is_pharmanet;
          
          // redirect to pharmanet
          if(data.url_pharmanet && isPharmanet && !isBidan) {
            window.location = data.url_pharmanet + '/login?token=' + data.token
            return
          }

          // redirect to bidan
          if(data.url_bidan && isBidan && !isPharmanet) {
            window.location = data.url_bidan + '/login?token=' + data.token
            return
          }

          // not first join
          if (!this.firstJoin) {
            this.setInitPage(false);
            if (data.tipe_faskes === "2") {
              if (data.klinik.alamat == null) {
                this.$router.push({
                  name: "home",
                  query: { cekAlamat: true }
                });
              } else if (data.quota_reminder == 0) {
                this.$router.push({
                  name: "home",
                  query: { cekPopUpReminder: true }
                });
              } else if (data.quota_reminder == 1) {
                this.$router.push({
                  name: "home",
                  query: { cekPopUpReminderHabis: true }
                });
              } else if (data.quota_reminder == 2) {
                this.$router.push({
                  name: "home",
                  query: { cekPopUpReminderHabis: true }
                });
              } else {
                this.$router.go("/");
              }
            } else {
              if (data.kliniks.length > 1) {
                this.$router.push({
                  name: "change-klinik"
                });
              } else {
                const kliniks = data.kliniks;
                if (kliniks.length > 0) {
                  this.$store.commit(
                    "SET_BPJS_AUTH_VALID",
                    kliniks[0].bpjs_auth_valid
                  );
                  this.$store.commit(
                    "SET_SATUSEHAT_AUTH_VALID",
                    kliniks[0].satusehat_auth_valid
                  );
                  this.$store.commit(
                    "SET_BRIDGING_ANTREAN_FKTP",
                    kliniks[0].bpjs_config.length > 0
                  );
                  this.$store.commit(
                    "SET_BRIDGING_ICARE",
                    data.bridging_icare
                  );
                  this.$store.commit("SET_BPJS_CONFIG", {
                    key: 'pcare_version',
                    value: kliniks[0].bpjs_config_pcare_version && kliniks[0].bpjs_config_pcare_version.length > 0 ? kliniks[0].bpjs_config_pcare_version[0].value : 0
                  });

                  this.$store.commit(
                    "SET_PEMANGGILAN_ANTREAN",
                    kliniks[0].antrean_uuid
                  );
                  this.$store.commit(
                    "SET_STATUS_QRIS_PAYMENT",
                    kliniks[0].qris_config,
                  );
                }

                const idKlinikUser = data.roles[0].pivot.model_id;
                this.$axios.get(`klinik/dokter/get-by-klinik-user/${idKlinikUser}`, {
                  headers: { Authorization: `Bearer ${data.token}` }
                }).then(res => {
                  if (res.data.data !== null) this.$store.commit("SET_DOKTER_ID", res.data.data.id);
                  this.$router.go("/");
                }).catch(err => {
                  console.log(err);
                });
              }
            }
          }
        } else if (
          status == false &&
          message == "Please check your email to activate user..."
        ) {
          this.$router.push({
            name: "verification-process",
            params: {
              email: postData.username,
              user_id: res.data.user_id,
              created_at: res.data.created_at,
              fromLogin: true
            }
          });
        } else {
          this.$swal({
            text: `Email/No. Handphone dengan password yang Anda masukan tidak cocok! Silakan cek kembali data Anda atau cek tipe akun yang telah dipilih.`,
            type: "warning"
          });

          this.failedCounter++;

          if (this.failedCounter >= maxFailed) {
            let timestamp = moment()
              .add(maxFailedCounter, "minutes")
              .unix();
            this.maxFailedTimestamp = timestamp;
            localStorage.setItem("__tmfl__", timestamp);
            this.failedCounter = 0;
          }
        }
      } catch (err) {
        this.loggedIn = false;
        if (err.response && err.response.status == 429) {
          let timestamp = moment()
            .add(maxFailedCounter, "minutes")
            .unix();
          this.maxFailedTimestamp = timestamp;
        }
      }
    },
    submitForm($event) {
      const { formBasicData } = this;
      if (formBasicData.every(item => item.error !== null && !item.error)) {
        this.login();
      } else {
        formBasicData.map(item => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this,
            rawLabel: item.rawLabel
          });
        });
      }
    },
    setFormData() {
      return this.setFormBasicData({
        noFilter: false
      }).reduce((arr, val) => {
        arr[val.label.split(" ").join("_")] = null;
        return arr;
      }, {});
    },
    setFormBasicData({ noFilter = true } = {}) {
      const tmp = [
        {
          label: "email/No.Handphone",
          placeholder: "Email / No. Handphone",
          type: "text",
          ignoreTransform: true,
          maxLength: 50
        },
        {
          label: "password",
          placeholder: "Password",
          type: "password",
          isType: "password",
          ignoreTransform: true,
          maxLength: 15
        }
      ].map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        placeholder: !item.ignoreTransform
          ? startCase(item.placeholder)
          : item.placeholder,
        rawLabel: item.label.split(".").join(". ")
      }));

      return noFilter
        ? tmp.filter(
            item => !item.parent || item.parent === this.selectedTipeFaskes
          )
        : tmp;
    },
    setValue({ label, rawLabel, $event = null } = {}) {
      const { target } = $event;
      const { value } = target;
      this.formData[label] = value && value.trim();
      this.triggerValidation({
        label,
        $v: this.$v,
        $vm: this,
        rawLabel
      });
    },
    isTooMuchFailed() {
      return this.failedCounter >= maxFailed;
    }
  }
};
</script>

<style scoped>
.form-login {
  margin-left: 15px;
}

@media only screen and (max-width: 990px) and (min-width: 660px) {
  .form-login {
    margin-left: auto;
    margin-right: auto;
  }
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
}

.wrap img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}

@media only screen and (max-width: 600px) {
  .form-login {
    margin-left: 25px;
    margin-right: 40px;
  }
}

@media only screen and (max-width: 767px) and (min-width: 576px) {
  .hide-image {
    display: none !important;
    margin-left: 25px;
    margin-right: 40px;
  }
}

@media only screen and (max-width: 1032px) and (min-width: 768px) {
  .form-login {
    margin-right: 30px;
  }
}

.card-radio-robot + .card {
  border: 2px solid grey;
  padding: 25px 10px;
  min-width: 200px;
}

.card-radio-robot + .card:hover {
  cursor: pointer;
}

.card-radio-robot:checked + .card {
  border: 2px solid #3784d9;
  -webkit-transition: border 0.3s;
  -o-transition: border 0.3s;
  transition: border 0.3s;
}

.text-blue {
  color: #3784d9;
}

.card-blue {
  background-color: #ecf4fc;
}
</style>
